module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand6-1c552fe081135168c16523206925a2e0.jpg";